import type { HTMLAttributeReferrerPolicy } from "react";

import type { InlineFrame } from "services/cms/models";
import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";

type LoadingType = "eager" | "lazy" | undefined;

export interface ResolvedInlineFrame {
    height?: number;
    width?: number;
    src: string;
    allowFullScreen: boolean;
    name: string;
    fetchpriority: string;
    loading: LoadingType;
    referrerPolicy: HTMLAttributeReferrerPolicy;
    allow: string;
    type: ContentTypeCodenames.InlineFrame;
    codename: string;
}

const inlineFrameResolver = (data: InlineFrame): ResolvedInlineFrame => {
    return {
        height: data.elements.height.value || undefined,
        width: data.elements.width.value || undefined,
        src: data.elements.src.value,
        allowFullScreen: data.elements.allowFullscreen?.value[0].codename === "true",
        name: data.elements.name.value,
        fetchpriority: data.elements.fetchPriority.value[0].codename,
        loading: data.elements.loading.value[0].codename as LoadingType,
        referrerPolicy: data.elements.reffererPolicy.value[0]
            ?.codename as HTMLAttributeReferrerPolicy,
        allow: data.elements.allow.value,
        type: ContentTypeCodenames.InlineFrame,
        codename: data.system.codename,
    };
};

export default inlineFrameResolver;
